<template>
  <div class="driver-detail" v-if="driver">
    <meta-data
      :meta-title="driver.metaTitle"
      :meta-description="driver.metaDescription"
      :key="driver.metaTitle"/>
    <page-header
      v-if="driver.headerImage"
      :layout="'driver'"
      :background-image="loading ? '' : `https://media.graphcms.com/resize=w:2800,fit:crop/output=format:jpg/quality=value:70/compress/${driver.headerImage.handle}`"
      :will-have-background-image="true"
      :break-after-to-white="true"
      :loading="loading"/>
    <div class="bg-white padding--bottom-4 text-default">
      <div class="container-fluid">
        <loader v-if="loading" :inverted="true"/>
        <driver-stage :driver="driver"/>
        <driver-car-info :car="driver.car"/>
      </div>
    </div>
    <div class="padding--bottom-4 padding--top-4">
      <div class="container-fluid">
        <template v-for="(module, index) in modules">
          <vertical-slider v-if="module.moduleName === 'VerticalSlider'" :key="`vertical-slider-${module.id}-${index}`" :slider-data="module"/>
        </template>
      </div>
    </div>
    <div class="bg-white padding--top-4 padding--bottom-4">
      <div class="container-fluid">
        <template v-for="(module) in modules">
          <plain-text v-if="module.moduleName === 'ModuleText'" :key="`text-${module.id}`" :data-obj="module" :class="'text-default'"/>
          <youtube v-if="module.moduleName === 'ModuleVideo'" :key="`youtube-${module.id}`" :data-obj="module" :class="'view padding--top-4 padding--bottom-4'"/>
          <image-text v-if="module.moduleName === 'ModuleImageText'" :key="`image-text-${module.id}`" :data-obj="module" :class="'text-default'"/>
          <image-gallery v-if="module.moduleName === 'ModuleGallery'" :key="`image-gallery-${module.id}`" :data-obj="module" :class="'text-default'"/>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import AppConst from '../config/app.const';
import Settings from '../config/settings';
import MetaData from '@/components/MetaData';
import PageHeader from '@/components/layout/PageHeader';
import Loader from '@/components/layout/Loader';
import DriverStage from '@/components/driver/DriverStage';
import DriverCarInfo from '@/components/driver/DriverCarInfo';
import VerticalSlider from '@/components/VerticalSlider';
import PlainText from '@/components/PlainText';
import Youtube from '@/components/Youtube';
import ImageText from '@/components/ImageText';
import ImageGallery from '@/components/ImageGallery';

export default {
  name: 'DriverDetail',
  components: { ImageGallery, ImageText, Youtube, PlainText, VerticalSlider, DriverCarInfo, DriverStage, Loader, PageHeader, MetaData },
  data () {
    return {
      slug: this.$route.params.slug,
      driver: null,
      loading: true,
      modules: null
    };
  },
  methods: {
    async fetchDriverDetail () {
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: `data?query=driverDetail&slug=${this.slug}`,
        lifetime: Settings.LIFETIME_DEFAULT
      })
        .then(respone => {
          this.driver = respone.drivers[0];
          // setup modules
          if (this.driver.moduleSets && this.driver.moduleSets.length > 0) {
            this.driver.moduleSets.forEach((moduleEntry) => {
              this.modules = moduleEntry.modules || null;
            });
          }
          this.loading = false;
          this.$store.commit(AppConst.ADD_LOCALIZATIONS, this.driver.localizations);
        });
    }
  },
  watch: {
    '$route.params.slug': function () {
      this.fetchDriverDetail();
    }
  },
  mounted () {
    this.fetchDriverDetail();
  }
};
</script>
